import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Input,
  InputAdornment,
  Tooltip,
  Avatar,
  Typography,
  Switch,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import CommonDataTable from "../../components/CommonDataTable";
import { capitalize } from "../../utils/helpers";
import errorHandler from "../../utils/errorHandler";
import {
  EditOutlined,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { GlobalServices } from "../../services/global";
import TableFilter from "../../components/shared/TableFilter";
import {
  IMAGE_BASE_URL,
  STATUS_OPTIONS_LIST,
  SEARCH_FIELD_SX,
  LIST_PAGE_HEADER_SX,
  LIST_PAGE_TOOLBAR_SX,
  LIST_PAGE_CARD_CONTENT_SX,
  LIST_PAGE_ADD_BUTTON_SX,
} from "../../utils/constants";
import { fDate } from "../../utils/formatTime";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function Category() {
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [warning, setWarning] = useState("");
  const [action, setAction] = useState("");
  const [show, setShow] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [statusId, setStatusId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [status, setStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderDelay, setLoaderDelay] = useState(false);
  const [globalsData, setGlobalsData] = useState({});

  const getFullUrl = (path) => {
    if (!path) return null;
    if (path instanceof File) return URL.createObjectURL(path);
    if (
      path.startsWith("http") ||
      path.startsWith("blob:") ||
      path.startsWith("data:")
    ) {
      return path;
    }
    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    return `${IMAGE_BASE_URL}/${cleanPath}`;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleClose = () => setShow(false);

  // const columns = [
  //   {
  //     name: "S.No.",
  //     width: "5%", // 100px se kam kar diya
  //     cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     name: "Image",
  //     width: "90px", // thoda compact
  //     cell: (row) => (
  //       <Avatar
  //         src={getFullUrl(row.image)}
  //         alt={row.name}
  //         sx={{ width: 40, height: 40 }} // avatar bhi chota
  //       />
  //     ),
  //   },
  //   {
  //     name: "Category Name",
  //     width: "20%", // fixed but reasonable
  //     selector: (row) => capitalize(row.name),
  //   },
  //   {
  //     name: "Subcategories",
  //     width: "28%", // fixed but reasonable
  //     cell: (row) => {
  //       const subs = row.subcategories || [];
  //       if (subs.length === 0) return "—";
  //       const visible = subs
  //         .slice(0, 3)
  //         .map((s) => capitalize(s))
  //         .join(", ");
  //       const remaining = subs.length - 3;
  //       return remaining > 0 ? `${visible}, +${remaining}` : visible;
  //     },
  //   },
  //   {
  //     name: "Description",
  //     width: "15%", // fixed but reasonable
  //     selector: (row) => capitalize(row.description),
  //   },
  //   {
  //     name: "Created At",
  //     width: "120px", // fixed but reasonable
  //     selector: (row) => fDate(row.createdAt),
  //   },
  //   {
  //     name: "Status",
  //     width: "90px",
  //     cell: (row) => (
  //       <Switch
  //         checked={row.status === "active"}
  //         onClick={() => {
  //           setShow(true);
  //           setCurrentStatus(row.status);
  //           setStatusId(row._id);
  //           setAction("status");
  //           setWarning(
  //             `Are you sure you want to ${
  //               row.status === "active" ? "deactivate" : "activate"
  //             } this main category?`,
  //           );
  //         }}
  //         color="primary"
  //       />
  //     ),
  //   },
  //   {
  //     name: "Actions",
  //     width: "12%",
  //     center: true,
  //     cell: (row) => (
  //       <Box display="flex" justifyContent="center">
  //         <Tooltip title="Manage Subcategories">
  //           <IconButton
  //             onClick={() => navigate(`/category/view/${row?._id}`)}
  //             sx={{ color: "primary.main" }}
  //           >
  //             <VisibilityIcon />
  //           </IconButton>
  //         </Tooltip>
  //         <Tooltip title="Edit Main Category">
  //           <IconButton
  //             onClick={() => navigate(`/category/edit/${row?._id}`)}
  //             sx={{ color: "primary.main" }}
  //           >
  //             <EditOutlined />
  //           </IconButton>
  //         </Tooltip>
  //         <Tooltip title="Delete Main Category">
  //           <IconButton
  //             onClick={() => deleteData(row?._id)}
  //             sx={{ color: "error.main" }}
  //           >
  //             <DeleteIcon />
  //           </IconButton>
  //         </Tooltip>
  //       </Box>
  //     ),
  //   },
  // ];

  const columns = [
    {
      name: "S.No.",
      width: "10%",
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
    },

    {
      name: "Category Name",
      width: "20%",
      selector: (row) => capitalize(row.name),
    },
    {
      name: "Subcategories",
      width: "40%",
      cell: (row) => {
        const subs = row.subcategories || [];
        if (subs.length === 0) return "—";
        const visible = subs
          .slice(0, 4)
          .map((s) => capitalize(typeof s === "object" ? (s.title || s.name || "") : s))
          .join(", ");
        const remaining = subs.length - 4;
        return remaining > 0 ? `${visible}, +${remaining}` : visible;
      },
    },

    {
      name: "Created At",
      width: "12%", // 120px → %
      selector: (row) => fDate(row.createdAt),
    },
    {
      name: "Status",
      width: "8%", // 90px → %
      cell: (row) => (
        <Switch
          checked={row.status === "active"}
          onClick={() => {
            setShow(true);
            setCurrentStatus(row.status);
            setStatusId(row._id);
            setAction("status");
            setWarning(
              `Are you sure you want to ${row.status === "active" ? "deactivate" : "activate"
              } this main category?`,
            );
          }}
          color="primary"
        />
      ),
    },
    {
      name: "Actions",
      width: "10%",
      center: true,
      cell: (row) => (
        <Box display="flex" justifyContent="center">
          <Tooltip title="Manage Subcategories">
            <IconButton
              onClick={() => navigate(`/category/view/${row?._id}`)}
              sx={{ color: "primary.main" }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit Main Category">
            <IconButton
              onClick={() => navigate(`/category/edit/${row?._id}`)}
              sx={{ color: "primary.main" }}
            >
              <EditOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Main Category">
            <IconButton
              onClick={() => deleteData(row?._id)}
              sx={{ color: "error.main" }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
  const deleteData = async (ids) => {
    const isMultiple = Array.isArray(ids);
    Swal.fire({
      text: isMultiple
        ? `Are you sure you want to delete ${ids.length} selected category(ies)?`
        : "Are you sure you want to delete this Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00a1da",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const categoryIds = isMultiple ? ids.map(Number) : [Number(ids)];

          if (!globalsData || !globalsData.vendorBusinessTypes) {
            toast.error("Global data not loaded.");
            return;
          }

          let businessTypes = [...globalsData.vendorBusinessTypes];
          businessTypes = businessTypes.filter(
            (_, idx) => !categoryIds.includes(idx),
          );

          // Format before payload — subcategories as array of objects { title, status, description }
          const formattedBusinessTypes = businessTypes.map((item) => {
            const subs = Array.isArray(item.subcategories)
              ? item.subcategories.map((s) => {
                if (typeof s === "object" && s) {
                  return { title: s.title || s.name || "", status: s.status || "active", description: s.description || "" };
                }
                return { title: String(s || ""), status: "active", description: "" };
              })
              : [];

            return {
              category: typeof item.category === "object" ? item.category : {
                title: typeof item.category === "string" ? item.category : "Unnamed",
                description: "",
                image: "",
                status: "active",
              },
              subcategories: subs,
            };
          });

          // Send FULL globals data to avoid validation errors for missing fields
          const payload = {
            ...globalsData,
            vendorBusinessTypes: formattedBusinessTypes,
          };

          // Clean internal mongo fields before sending
          delete payload._id;
          delete payload.createdAt;
          delete payload.updatedAt;
          delete payload.__v;

          const res = await GlobalServices.updateGlobalSettings(payload);
          if (res?.data?.status) {
            toast.success("Deleted successfully", { toastId: "success" });
            if (!isMultiple) {
              setData((prevData) =>
                prevData.filter((item) => item._id !== ids),
              );
              setTotalCount((prevTotal) => prevTotal - 1);
            } else {
              setData((prevData) =>
                prevData.filter((item) => !ids.includes(item._id)),
              );
              setTotalCount((prevTotal) => Math.max(0, prevTotal - ids.length));
            }
            setRefresh(!refresh);
          } else {
            toast.error(res?.data?.message || "Failed to delete", {
              toastId: "error",
            });
          }
        } catch (error) {
          console.error("Error deleting...", error);
          errorHandler(error);
        }
      }
    });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setDebouncedSearch(searchItem);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchItem]);

  useEffect(() => {
    // STATUS_OPTIONS_LIST uses: { value: 1, label: "Active" }, { value: 0, label: "Inactive" }
    const statusStrings = status.map((s) => (s === 1 ? "active" : "inactive"));

    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: pageSize,
    };

    // Only add status if user has explicitly selected filters
    if (statusStrings.length > 0) {
      body.status = statusStrings;
    }

    setIsLoading(true);
    setLoaderDelay(false);

    GlobalServices.getAllGlobalSettings()
      .then((res) => {
        if (res?.data?.status) {
          const globals = res.data.data;
          // Store globals globally to use in delete
          setGlobalsData(globals);

          const businessTypes = globals.vendorBusinessTypes || [];

          let categories = businessTypes.map((item, index) => {
            const catObj = item.category || {};
            return {
              _id: index.toString(),
              name: typeof catObj === "string" ? catObj : catObj.title || "",
              description:
                typeof catObj === "string" ? "" : catObj.description || "",
              image: typeof catObj === "string" ? "" : catObj.image || "",
              subcategories: item.subcategories || [],
              status: (typeof catObj === "object" ? catObj.status : item.status) || "active",
              createdAt: new Date().toISOString(),
            };
          });

          if (debouncedSearch) {
            categories = categories.filter((c) =>
              c.name.toLowerCase().includes(debouncedSearch.toLowerCase()),
            );
          }

          // Filter by status if user has selected status filters
          const statusStrings = status.map((s) =>
            s === 1 ? "active" : "inactive",
          );
          const filteredByStatus =
            statusStrings.length > 0
              ? categories.filter((c) => statusStrings.includes(c.status))
              : categories;

          // Client-side pagination
          setTotalCount(filteredByStatus.length);
          const startIndex = (currentPage - 1) * pageSize;
          const paginated = filteredByStatus.slice(
            startIndex,
            startIndex + pageSize,
          );

          setTimeout(() => {
            setData(paginated);
            setLoaderDelay(true);
          }, 500);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        errorHandler(err);
      })
      .finally(() => {
        setIsLoading(false);
        setLoaderDelay(false);
      });
  }, [debouncedSearch, currentPage, pageSize, refresh, status]);

  const toggleChecked = async (toggleId, currentSt) => {
    try {
      const newStatus = currentSt === "active" ? "inactive" : "active";

      if (!globalsData || !globalsData.vendorBusinessTypes) {
        toast.error("Global data not loaded.");
        setShow(false);
        return;
      }

      // Clone businessTypes and update status on the target category
      const businessTypes = globalsData.vendorBusinessTypes.map((item, idx) => {
        if (idx === Number(toggleId)) {
          const catObj = typeof item.category === "object" ? item.category : {};
          return {
            ...item,
            category: {
              ...catObj,
              title: typeof item.category === "string" ? item.category : (catObj.title || catObj.name || ""),
              status: newStatus,
            },
          };
        }
        return item;
      });

      // Format for API: subcategories as array of objects { title, status, description }
      const formattedBusinessTypes = businessTypes.map((item) => {
        const catObj = typeof item.category === "object" ? item.category : {};
        const subs = Array.isArray(item.subcategories)
          ? item.subcategories.map((s) => {
            if (typeof s === "object" && s) {
              return { title: s.title || s.name || "", status: s.status || "active", description: s.description || "" };
            }
            return { title: String(s || ""), status: "active", description: "" };
          })
          : [];

        return {
          category: typeof item.category === "object" ? item.category : {
            title: typeof item.category === "string" ? item.category : "Unnamed",
            description: "",
            image: "",
            status: "active",
          },
          subcategories: subs,
        };
      });

      const payload = {
        ...globalsData,
        vendorBusinessTypes: formattedBusinessTypes,
      };

      delete payload._id;
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.__v;

      const res = await GlobalServices.updateGlobalSettings(payload);

      if (res?.data?.status) {
        // Update local state to reflect the toggle
        setData((prevData) =>
          prevData.map((item) =>
            item._id === toggleId ? { ...item, status: newStatus } : item,
          ),
        );
        toast.success(
          `Category ${newStatus === "active" ? "activated" : "deactivated"} successfully`,
          { toastId: "success1" },
        );
      } else {
        toast.error(res?.data?.message || "Failed to update status", {
          toastId: "error",
        });
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setShow(false);
    }
  };

  return (
    <Card>
      <CardHeader
        titleTypographyProps={{ variant: "h4" }}
        title="Business Categories"
        sx={LIST_PAGE_HEADER_SX}
      />
      <Box className="list-page-toolbar" sx={LIST_PAGE_TOOLBAR_SX}>
        <TableFilter
          data={STATUS_OPTIONS_LIST}
          value={status}
          setValue={setStatus}
          filterName="Status"
        />
        <Input
          label="Search"
          variant="standard"
          value={searchItem}
          placeholder="Search"
          onChange={(e) => setSearchItem(e.target.value)}
          sx={SEARCH_FIELD_SX}
          endAdornment={
            searchItem ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="clear-search"
                  size="small"
                  onClick={() => setSearchItem("")}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          }
        />
        <Button
          type="submit"
          variant="contained"
          onClick={() => navigate("/category/add")}
          sx={LIST_PAGE_ADD_BUTTON_SX}
        >
          Add Category
        </Button>
      </Box>
      <CardContent sx={LIST_PAGE_CARD_CONTENT_SX}>
        <CommonDataTable
          columns={columns}
          data={data}
          isLoading={isLoading || !loaderDelay}
          totalCount={totalCount}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onRowsPerPageChange={(rows) => {
            setPageSize(rows);
            setCurrentPage(1);
          }}
        />
      </CardContent>
      <Dialog
        open={show}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="popupbox-statis"
      >
        <DialogTitle as="h3">{warning}</DialogTitle>
        <DialogActions className="status-box-action">
          <Button
            variant="outlined"
            onClick={() => {
              if (action === "status") {
                toggleChecked(statusId, currentStatus);
              }
            }}
          >
            Yes
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
